import Api from "./api";

const UserService = {
  checkUserEmail: (email, inOutlook, outlookToken) => {
    return Api.callApi('/find_application', 'POST', {
      user: {
        inOutlook: inOutlook,
        email: email,
        token: outlookToken
      }
    })
  },

  login: (email, password, otp_attempt) => {
    return Api.callApi('/users/sign_in', 'POST', {
      user: {
        email: email,
        password: password,
        otp_attempt: otp_attempt
      }
    })
  },

  confirmCode: (confirmationCode, email, inOutlook) => {
    return Api.callApi('/confirm_code', 'POST', {
      user: {
        email: email,
        inOutlook: inOutlook,
        confirmation_code: confirmationCode,
      }
    })
  },

  signUp: (params) => {
    return Api.callApi('/users', 'POST', {
      user: {
        email: params.email,
        first_name: params.name,
        preposition: params.preposition,
        last_name: params.lastName,
        password: params.password,
        password_confirmation: params.confirmPassword,
        company_short_code: params.companyShortCode,
      }
    })
  },

  forgotPassword: (email) => {
    return Api.callApi('/users/password', 'POST', {
      user: {
        email: email
      }
    })
  },

  updatePassword: (password, confirmPassword, resetPasswordToken) => {
    return Api.callApi('/users/password', 'PATCH', {
      user: {
        password: password,
        password_confirmation: confirmPassword,
        reset_password_token: resetPasswordToken
      }
    })
  },

  checkSession: () => {
    return Api.callApi('/sessions/session_information', 'GET')
  },

  otpInfo: () => {
    return Api.callApi('/users/otp_info', 'GET')
  },


  authenticate: (params) => {
    return Api.callApi('/oauth/authorize', 'POST', params)
  },

  confirmOTP: (params) => {
    return Api.callApi('/users/confirm_otp', 'PATCH', params)
  }
};

export default UserService;
